// src/utils/emptyStateUtils.ts

/**
 * Comprehensive empty state checker that detects all types of empty values
 * including string representations of empty arrays/objects
 */
export const isEmpty = (value: any): boolean => {
  // Check for null or undefined
  if (value === null || value === undefined) {
    return true;
  }

  // Check for empty string
  if (value === '') {
    return true;
  }

  // Check for string representations of empty array/object
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (trimmed === '[]' || trimmed === '{}') {
      return true;
    }
  }

  // Check for empty array
  if (Array.isArray(value)) {
    return value.length === 0;
  }

  // Check for empty object
  if (typeof value === 'object' && value !== null) {
    return Object.keys(value).length === 0;
  }

  return false;
};

/**
 * Check if site content data is empty or invalid
 * Only checks siteContent.widgets
 */
export const isSiteContentEmpty = (siteContent: any): boolean => {
  if (!siteContent) {
    return true;
  }

  // Only check if widgets array is empty
  if (isEmpty(siteContent.widgets)) {
    return true;
  }

  return false;
};
